module.exports = __webpack_public_path__ + "img/sampleb.785d8dee.png";